"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ENUM_RIGHT = exports.ENUM_LEFT = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bindAll = _interopRequireDefault(require("lodash/bindAll"));

var _classnames = _interopRequireDefault(require("classnames"));

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
// Enums
var ENUM_LEFT = -1;
exports.ENUM_LEFT = ENUM_LEFT;
var ENUM_RIGHT = 1;
exports.ENUM_RIGHT = ENUM_RIGHT;

var BaseStepper = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(BaseStepper, _React$Component);

  var _super = (0, _createSuper2.default)(BaseStepper);

  function BaseStepper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, BaseStepper);
    _this = _super.call(this, props);
    (0, _bindAll.default)((0, _assertThisInitialized2.default)(_this), ['startStepCount', 'stopStepCount', 'renderHandle']);
    return _this;
  }

  (0, _createClass2.default)(BaseStepper, [{
    key: "startStepCount",
    value: function startStepCount(direction) {
      var _this2 = this;

      this.stopStepCount(direction, false);
      this.timeoutId = window.setTimeout(function () {
        // Start an interval for the stepper to trigger infinitely.
        _this2.intervalId = window.setInterval(function () {
          try {
            // Is the button disabled ?
            if (_this2.props.isHandleDisabled(direction)) {
              // Stop the step count.
              _this2.stopStepCount(direction);
            } else {
              // Handle the step in an interval.
              _this2.props.onHandleChange(direction, true);
            }
          } catch (e) {
            // End the click now or the interval will run infinitely.
            _this2.stopStepCount(direction);
          }
        }, 100);
      }, 300);
    }
  }, {
    key: "stopStepCount",
    value: function stopStepCount(direction, finalIncrement) {
      // Do we need one final increment ?
      if (finalIncrement === true) {
        this.props.onHandleChange(direction, false);
      } // Clear the timeouts and intervals.


      window.clearInterval(this.intervalId);
      window.clearTimeout(this.timeoutId);
      delete this.intervalId;
      delete this.timeoutId;
    }
  }, {
    key: "renderHandle",
    value: function renderHandle(direction) {
      var classes = (0, _classnames.default)('stepper-handle', {
        'stepper-handle-left': direction === ENUM_LEFT,
        'stepper-handle-right': direction === ENUM_RIGHT,
        disabled: this.props.isHandleDisabled(direction)
      }); // TODO should be a button and should not bind

      /* eslint-disable  jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */

      return /*#__PURE__*/_react.default.createElement("div", {
        onMouseDown: this.startStepCount.bind(this, direction),
        onTouchStart: this.startStepCount.bind(this, direction),
        onClick: this.stopStepCount.bind(this, direction, true),
        onMouseLeave: this.stopStepCount.bind(this, direction),
        onTouchEnd: this.stopStepCount.bind(this, direction),
        className: classes
      });
      /* eslint-enable  jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
    }
  }, {
    key: "render",
    value: function render() {
      var stepperContent = this.props.hasNumericInput ? /*#__PURE__*/_react.default.createElement("input", {
        className: "stepper-content",
        value: this.props.value,
        type: "tel",
        onClick: this.props.onTextInputClick,
        onChange: this.props.onTextInputChange,
        onBlur: this.props.onTextInputBlur,
        onFocus: this.props.onTextInputFocus,
        onKeyPress: this.props.onKeyPress
      }) : /*#__PURE__*/_react.default.createElement("div", {
        className: "stepper-content"
      }, this.props.value);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "nw-stepper"
      }, this.renderHandle(ENUM_LEFT), stepperContent, this.renderHandle(ENUM_RIGHT));
    }
  }]);
  return BaseStepper;
}(_react.default.Component); // Export the left and right enums


exports.default = BaseStepper;
(0, _defineProperty2.default)(BaseStepper, "displayName", 'BaseStepper');
(0, _defineProperty2.default)(BaseStepper, "propTypes", {
  hasNumericInput: _propTypes.default.bool,
  isHandleDisabled: _propTypes.default.func,
  onHandleChange: _propTypes.default.func.isRequired,
  onKeyPress: _propTypes.default.func,
  onTextInputBlur: _propTypes.default.func,
  onTextInputChange: _propTypes.default.func,
  onTextInputClick: _propTypes.default.func,
  onTextInputFocus: _propTypes.default.func,
  value: _propTypes.default.any.isRequired // eslint-disable-line react/forbid-prop-types

});
(0, _defineProperty2.default)(BaseStepper, "defaultProps", {
  hasNumericInput: false,
  isHandleDisabled: function isHandleDisabled() {},
  onKeyPress: function onKeyPress() {},
  onTextInputBlur: function onTextInputBlur() {},
  onTextInputChange: function onTextInputChange() {},
  onTextInputClick: function onTextInputClick() {},
  onTextInputFocus: function onTextInputFocus() {}
});